var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-responsive" },
    [
      _c(
        "table-component",
        {
          ref: "table",
          attrs: {
            "show-filter": false,
            data: _vm.prepaymentRequest,
            "table-class": "table",
          },
        },
        [
          _c("table-column", {
            attrs: {
              label: _vm.$t("prepayments.date"),
              show: "formattedPrePaymentDate",
            },
          }),
          _vm._v(" "),
          _vm.userType === "anchor" ||
          _vm.userType === "super_admin" ||
          _vm.userType === "supplier"
            ? _c("table-column", {
                attrs: { label: _vm.$t("general.promised_payment_date") },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (row) {
                        return [
                          _vm.$route.name ===
                            "preapproved-invoice-request-view-supplier" ||
                          _vm.$route.name === "preapproved.invoice.offer"
                            ? _c("p", [
                                _vm._v(
                                  _vm._s(
                                    row.invoice.formattedPromisedPaymentDate
                                  )
                                ),
                              ])
                            : _c("p", [
                                _vm._v(
                                  _vm._s(row.formattedPromisedPaymentDate)
                                ),
                              ]),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2911160467
                ),
              })
            : _c("table-column", {
                attrs: { label: _vm.$t("general.promised_payment_date") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (row) {
                      return [
                        _c("p", [
                          _vm._v(_vm._s(row.formattedPromisedPaymentDate)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
          _vm._v(" "),
          _vm.userType == "supplier" || _vm.userType == "funder"
            ? _c("table-column", {
                attrs: {
                  label: _vm.$t("prepayments.offer_expire"),
                  show: "formattedOfferExpire",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (row) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("general.offer_amount"))),
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(row.formattedOfferExpire),
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2343244761
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              label: _vm.$t("general.request_number"),
              show: "prepayment_number",
            },
          }),
          _vm._v(" "),
          _vm.userType == "super_admin"
            ? _c("table-column", {
                attrs: {
                  label: _vm.$t("prepayments.offer_requested_on_date"),
                  show: "formattedSupplierOfferRequestDate",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (row) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("prepayments.offer_requested_on_date")
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                row.formattedSupplierOfferRequestDate
                              ),
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2410921194
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              label: _vm.$t("general.request_amount"),
              "sort-as": "request_amount",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("general.request_amount"))),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$utils.formatMoney(
                            row.requested_amount,
                            row.invoice.customer.currency
                          )
                        ),
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              label: _vm.$t("general.offer_amount"),
              "sort-as": "total",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("general.offer_amount"))),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$utils.formatMoney(
                            row.amount,
                            row.invoice.customer.currency
                          )
                        ),
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              label: _vm.$t("prepayments.rate_of_pre_payment"),
              show: "rate_of_prepayment",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (row) {
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.$t("prepayments.amount")))]),
                    _vm._v(
                      "\n        " +
                        _vm._s(row.rate_of_prepayment) +
                        " %\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _vm.userType == "funder" ||
          _vm.userType == "super_admin" ||
          _vm.userType == "supplier"
            ? _c("table-column", {
                attrs: {
                  label: _vm.$t("general.financing_ratio"),
                  show: "margin",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (row) {
                        return [
                          _c("span", [
                            _vm._v(_vm._s(_vm.$t("general.financing_ratio"))),
                          ]),
                          _vm._v(
                            "\n        " +
                              _vm._s(row.margin_rate) +
                              " %\n      "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  4194067127
                ),
              })
            : _vm._e(),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              label: _vm.$t("prepayments.supplier_comment"),
              show: "supplier_comment",
            },
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              label: _vm.$t("prepayments.anchor_comment"),
              show: "anchor_comment",
            },
          }),
          _vm._v(" "),
          _c("table-column", {
            attrs: {
              label: _vm.$t("prepayments.administrator_comment"),
              show: "superAdmin_comment",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }